// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3bMac","paramInput":"JobSimulator_paramInput__2iQFw","input":"JobSimulator_input__6iw3L"};